/**
 * @file Metadata/constants.js
 */

export const HIDDEN_LABELS_LIST = ["canada", "homepage", "csou-episodes"];

export const OLYMPICS_HIDDEN_LABELS = [
    "sports",
    "olympics",
    "summer",
    "winter",
];
